import { connect } from "react-redux";
import { Dispatch } from "redux";
import GeschlechtComponent from "./geschlecht.component";
import {
  ProzessInputData,
  prozessDataChanged,
  givenDataApplied,
} from "../../../store/prozess-events/prozess-events.actions";
import { AppState } from "../../../store/app.state";
import {
  getCurrentRecordId,
  getGivenDataByWorkflowId,
} from "../../../store/prozess-events/prozess-events.selectors";
import { ConnectedDispatch, ConnectedState, OwnProps } from "./geschlecht.types";
import {
  getIsManuallyEmpty,
  getShouldCreateProzessEventForMultipleProzess,
  isEditModeActivated,
} from "../../../store/common/common.selectors";
import { getEditedValueByWorkflowId } from "../../../store/captured-records/captured-records.selectors";

const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedState => {
  const workflowId = ownProps.prozess.workflowId!;

  return {
    givenData: getGivenDataByWorkflowId(workflowId)(state),
    prevRecordId: getCurrentRecordId(state),
    isManuallyEmpty: getIsManuallyEmpty(state),
    shouldCreateProzessEventForMultipleProzess: getShouldCreateProzessEventForMultipleProzess(state),
    editedValue: getEditedValueByWorkflowId(workflowId)(state),
    isEditing: isEditModeActivated(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ConnectedDispatch => ({
  onChanged: (prozessInputData: ProzessInputData) => dispatch(prozessDataChanged(prozessInputData)),
  givenDataApplied: (workflowId: number) => dispatch(givenDataApplied(workflowId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeschlechtComponent);
